import { atom } from "recoil";

const clientstateAtom = atom({

    key:"clientState",
    default: []

});

export default clientstateAtom;